export enum OidcContext {
  DEFAULT = "default",
  TVM = "tvm",
}

export interface OidcAppConfiguration {
  oidcContext: OidcContext;
  pathAuthorize: string;
  pathLogin: string;
  pathLogout: string;
}

export interface IdpConfiguration {
  authority: string;
  client_id: string;
  scope: string;
}

export enum OidcPath {
  AUTHORIZE = "authorize",
  LOGIN = "login",
  LOGOUT = "logout",
}
